module.exports = __webpack_public_path__ + "img/Solace_round.626369f0.png";